import { atom } from 'recoil';

export const ShowMetaDataState = atom({
    key: 'ShowMetaDataState',
    default: {
        type: '',
        show: false,
    }
});